// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3F6Fk","questions":"styles_questions__3NHb8","footer":"styles_footer__32Ow5"};